import { jsxs, jsx } from "react/jsx-runtime";
import { Logo } from "@seek/logo";
import { Link, HiddenVisually } from "braid-design-system";
import { useLink } from "../../../ApacCandidateFooter/components/Accordion/Accordion.mjs";
import { useApacCandidateHeaderContext } from "../../ApacCandidateHeader.mjs";
import { logo } from "./Logo.css.mjs";
const HeaderLogo = ({
  href,
  isInvert = false,
  linkContext,
  seoText,
  brand
}) => {
  const { injectLinkContextToData } = useLink();
  const { isMenuOpen, setIsMenuOpen } = useApacCandidateHeaderContext();
  const variant = isInvert ? "inverted" : "standard";
  return /* @__PURE__ */ jsxs(
    Link,
    {
      href,
      className: logo,
      data: injectLinkContextToData(linkContext, {
        automation: linkContext.source
      }),
      onClick: () => isMenuOpen && setIsMenuOpen(false),
      children: [
        seoText && /* @__PURE__ */ jsx(HiddenVisually, { data: { automation: seoText.toLocaleLowerCase() }, children: seoText }),
        /* @__PURE__ */ jsx(Logo, { variant, brand, size: "standard" })
      ]
    }
  );
};
export {
  HeaderLogo
};
